import { usePage } from "@inertiajs/react"
import type { ReactNode } from "react"

import HelpScoutBeacon from "@/components/help-scout-beacon"
import LiveNotificationSubscriber from "@/components/notifications/live-notification-subscriber"
import PushNotificationPrompt from "@/components/notifications/push-notification-prompt"
import { PostHogIdentityLifecycle } from "@/components/posthog-provider"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"
import type { SharedData } from "@/types"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  const page = usePage<SharedData>()
  useFlash()
  return (
    <>
      <PostHogIdentityLifecycle />
      <LiveNotificationSubscriber />
      <PushNotificationPrompt
        shouldPrompt={page.props.pushNotificationPrompt?.shouldPrompt}
        vapidPublicKey={page.props.pushNotificationPrompt?.vapidPublicKey}
      />
      <HelpScoutBeacon />
      {children}
      <Toaster richColors position="top-center" />
    </>
  )
}
